import { useBreadcrumbs, type BreadcrumbItem } from '@/features/_hooks/use-breadcrumbs'
import { useIsRouteActive } from '@/features/_hooks/use-is-route-active'
import type { TExposedCompanyDTO } from '@doutorsim/shared/companies'
import type { TExposedFacilityDTO } from '@doutorsim/shared/facilities'
import { PageHeader } from '../../../_components/ui/page-header'

interface FacilityHeaderProps {
  company: TExposedCompanyDTO
  facility: TExposedFacilityDTO
  backHref: string
  breadcrumbs: BreadcrumbItem[]
}

export const FacilityHeader = ({
  company,
  facility,
  backHref,
  breadcrumbs,
}: FacilityHeaderProps) => {
  const isPersonRouteActive = useIsRouteActive('facilities', 'applications')
  const isSettingsRouteActive = useIsRouteActive('facilities', 'settings')

  useBreadcrumbs(breadcrumbs)

  const base = `/companies/${company.slug}/facilities/${facility.slug}`

  return (
    <PageHeader
      title={facility.name}
      backHref={backHref}
      tabs={[
        {
          label: 'Pacientes',
          href: `${base}/applications`,
          isActive: isPersonRouteActive,
        },
        {
          label: 'Configurações',
          href: `${base}/settings`,
          isActive: isSettingsRouteActive,
        },
      ]}
    />
  )
}
